module.exports = __webpack_public_path__ + "media/creativeMedia/panel03-606ffd37.png";